import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import defaultStyles from './AttributesSelector.module.css';
import jlrStyles from './AttributesSelectorJlr.module.css';
import { Button } from '@material-ui/core';
import ViewColumnSharpIcon from '@material-ui/icons/ViewColumnSharp';
import AttributesMenu from '../AttributesMenu/AttributesMenu';
import {
  optionalColumnsWithShift as defaultOptionalColumns,
  optionalColumnsForPVWithShift,
  optionalColumnsExceptCv,
} from '../../staticData';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { setStylesAccordingToPlant } from '../../utils/utils';
import { APPLICATION_VARIANTS } from '../../constants';
import config from '../../config/config';

const AttributesSelector = ({
  attributeSelectorForChassisSequence,
  applyColumnsSelection,
  columns = defaultOptionalColumns,
  selectedOptionalCols,
  buttonClassName,
  isShiftPresent,
}) => {
  const buttonRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [styles, setStyles] = useState(defaultStyles);
  const [plant] = usePlantAndLinesStore().plantState;

  const openMenu = () => setIsMenuOpen(true);
  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]);

  return (
    <>
      <Button
        ref={buttonRef}
        className={
          attributeSelectorForChassisSequence
            ? clsx(styles.toolButtonForChassis, buttonClassName)
            : clsx(styles.toolButton, buttonClassName)
        }
        onClick={openMenu}
      >
        <ViewColumnSharpIcon className={styles.toolIcon} />
        Attributes
      </Button>
      <AttributesMenu
        open={isMenuOpen}
        columns={
          config?.APPLICATION_VARIANT === APPLICATION_VARIANTS.IPMS4
            ? columns.map(column => column.name)
            : isShiftPresent
            ? optionalColumnsForPVWithShift.map(column => column.name)
            : optionalColumnsExceptCv.map(column => column.name)
        }
        selectedOptionalCols={selectedOptionalCols}
        handleApply={applyColumnsSelection}
        handleClose={closeMenu}
        anchorEl={buttonRef.current}
      />
    </>
  );
};

AttributesSelector.propTypes = {
  applyColumnsSelection: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedOptionalCols: PropTypes.arrayOf(PropTypes.string).isRequired,
  buttonClassName: PropTypes.string,
};

export default AttributesSelector;
